// extracted by mini-css-extract-plugin
export default {"container":"PetFriendly_container__-BEfF","titulo":"PetFriendly_titulo__08hWW","lista":"PetFriendly_lista__V6gbB"};